export interface ColumnConfig {
  id: string;
  label: string;
  visible: boolean;
  sortable: boolean;
  resizable: boolean;
}

export const DEFAULT_AUDIT_HISTORY_COLUMNS: ColumnConfig[] = [
  { id: 'auditNumber', label: 'Audit No.', visible: true, sortable: true, resizable: true },
  { id: 'title', label: 'Audit Title', visible: true, sortable: true, resizable: true },
  { id: 'type', label: 'Type', visible: true, sortable: true, resizable: true },
  { id: 'status', label: 'Status', visible: true, sortable: true, resizable: true },
  { id: 'totalAssets', label: 'Total Assets', visible: true, sortable: true, resizable: true },
  { id: 'completedAssets', label: 'Completed Assets', visible: true, sortable: true, resizable: true },
  { id: 'completionPercentage', label: 'Completion %', visible: true, sortable: true, resizable: true },
  { id: 'actualEndDate', label: 'Completed Date', visible: true, sortable: true, resizable: true },
  { id: 'createdDate', label: 'Created Date', visible: false, sortable: true, resizable: true },
  { id: 'createdByName', label: 'Created By', visible: false, sortable: true, resizable: true },
  { id: 'exceptionCount', label: 'Exceptions', visible: false, sortable: true, resizable: true },
];
